module.exports = __webpack_public_path__ + "67b208a00ee8d060067c02146f4c057c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/components/css-logo.svg
// module id = 662
// module chunks = 0